import { LazyLoader, Modal } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';

type LoadingModalProps = {
  isOpen: boolean;
  message?: string;
  onClose: () => void;
};

export const LoadingModal = ({ isOpen, message, onClose }: LoadingModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      width='s'
      hideCloseButton
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClick={false}
      isOpen={isOpen}
      onRequestClose={() => onClose()}
    >
      <LazyLoader embedded size='xxl' label={message ?? t('common.actionInProgress')} />
    </Modal>
  );
};
